import { type GenericDetailQueryKey, generateDetailQueryKey } from '@pba/react-query';

import { nodeUsersFeatureKey } from '../key';

type NodeUserDetailQueryType = GenericDetailQueryKey;

export const getNodeUserDetailQueryKey = generateDetailQueryKey({
  prefix: nodeUsersFeatureKey,
})<NodeUserDetailQueryType>;
